import React from 'react';
import LegalLayout from './LegalLayout';

export default function CookieNotice() {
  return (
    <LegalLayout title="Cookie Notice" lastUpdated="22 May 2026">
      <p>
        At Starlight Sanctuary, we respect your digital footprint. We do not use any invasive tracking, advertising pixels, or third-party marketing cookies.
      </p>

      <h2>Strictly Necessary Cookies Only</h2>
      <p>
        Our platform relies exclusively on <strong>strictly necessary cookies</strong> to function securely and reliably. These include:
      </p>
      <ul>
        <li><strong>Authentication (Supabase):</strong> To securely manage your session and keep you logged into the sanctuary.</li>
        <li><strong>Payments & Fraud Prevention (Stripe):</strong> To safely process your subscription transactions and prevent fraudulent activity.</li>
      </ul>

      <p>
        Because these cookies are essential for the fundamental operation and security of the platform, they cannot be disabled. By using Starlight Sanctuary, you acknowledge the use of these strictly necessary technical cookies.
      </p>
    </LegalLayout>
  );
}
